import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import cc from "currency-codes";
import { getAuthToken } from "../../utils/auth";
import Header from "../Header";
import Footer from "../Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchSingleUser } from "../../utils/UserComponents";
const Base_Url = process.env.REACT_APP_BASE_URL;

const countries = cc.countries().map((name) => ({
  value: name,
  label: name,
}));

const EditUser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setloading] = useState(false);
  const role = localStorage.getItem("role");
  const [showOptions, setShowOptions] = useState({
    eTranferOption: false,
    paypalOption: false,
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const id = location.pathname.split("/").pop();
    fetchSingleUser(id, setUserDetails);
    setloading(false);
  }, [location.pathname]);

  const onUserChange = (e) => {
    const { name, value } = e.target;
    if (name in userDetails.bankDetails) {
      setUserDetails({
        ...userDetails,
        bankDetails: { ...userDetails.bankDetails, [name]: value },
      });
    } else {
      setUserDetails({ ...userDetails, [name]: value });
    }
  };

  const handleCountryChange = (selectedOption) => {
    setUserDetails({ ...userDetails, country: selectedOption });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // setProfilePhoto(URL.createObjectURL(file));
      setSelectedFile(file);
    }
  };

  const validateUserDetails = () => {
    const errors = {};
    if (!userDetails.firstName) errors.firstName = "First Name is required";
    if (!userDetails.lastName) errors.lastName = "Last Name is required";
    if (!userDetails.email) errors.email = "Email is required";
    if (!userDetails.password) errors.password = "Password is required";
    if (!userDetails.country) errors.country = "Country is required";
    return errors;
  };

  const handleSave = async () => {
    const validationErrors = validateUserDetails();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        setloading(true);
        const token = getAuthToken();
        if (token) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          let allData = new FormData();
          allData.append("userDetails", JSON.stringify(userDetails));
          if (selectedFile) {
            allData.append("profilePhoto", selectedFile);
          }
          const id = location.pathname.split("/").pop();
          await axios.post(
            `${process.env.REACT_APP_BASE_URL}/api/user/edit/${id}`,
            allData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          setTimeout(() => {
            toast.success("Profile updated successfully!");
          }, 1000);
          setTimeout(() => {
            setloading(false);
          }, 1000);
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        }
      } catch (err) {
        setErrors({
          server: "Failed to update user details. Please try again.",
        });
        toast.error("Failed to update profile.");
      }
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      <Header />
      <ToastContainer />

      <div className="edit-profile-container">
        <form className="edit-profile-form">
          <h2 className="heading">Edit Profile</h2>
          <p className="headingP">
            Enter bank details according to your country
          </p>
          <div className="edit-photo-section">
            <div
              className="edit-profile-photo-container"
              onClick={() => fileInputRef.current.click()}
            >
              {selectedFile ? (
                <img src={URL.createObjectURL(selectedFile)} alt="Profile" />
              ) : userDetails.profilePhoto ? (
                <img
                  src={`${Base_Url}/assets/profilePhotos/${userDetails.profilePhoto}`}
                  alt="Profile"
                />
              ) : (
                <FontAwesomeIcon icon={faPlus} />
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handlePhotoChange}
            />
          </div>
          <div className="details">
            <div className="form-row">
              <div className="row-edit">
                <input
                  type="text"
                  name="firstName"
                  value={userDetails.firstName}
                  onChange={onUserChange}
                  placeholder="First Name"
                />
                {errors.firstName && (
                  <p className="error">{errors.firstName}</p>
                )}
              </div>
              <div className="row-edit">
                <input
                  type="text"
                  name="lastName"
                  value={userDetails.lastName}
                  onChange={onUserChange}
                  placeholder="Last Name"
                />
                {errors.lastName && <p className="error">{errors.lastName}</p>}
              </div>
            </div>

            <div className="form-row">
              <div className="row-edit">
                <input
                  type="email"
                  name="email"
                  value={userDetails.email}
                  onChange={onUserChange}
                  placeholder="Email"
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              <div className="row-edit">
                <div className="inner-div password-container">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="password"
                    value={userDetails.password}
                    onChange={onUserChange}
                    placeholder="Password"
                  />
                  <FontAwesomeIcon
                    icon={showConfirmPassword ? faEyeSlash : faEye}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="password-toggle-icon"
                  />
                </div>
                {errors.password && <p className="error">{errors.password}</p>}
              </div>
            </div>

            <div className="form-row">
              <Select
                options={countries}
                value={countries.find(
                  (country) => country.value === userDetails.country
                )}
                onChange={handleCountryChange}
                placeholder="Country"
                className="select-edit-form"
              />
              {errors.country && <p className="error">{errors.country}</p>}
            </div>

            {role !== "admin" && (
              <>
                <p className="input-head">Account Details</p>
                <div className="form-row">
                  <div className="row-edit">
                    <input
                      type="text"
                      name="accountNumber"
                      value={userDetails.bankDetails?.accountNumber}
                      onChange={onUserChange}
                      placeholder="Account Number"
                    />
                    {errors.accountNumber && (
                      <p className="error">{errors.accountNumber}</p>
                    )}
                  </div>
                  <div className="row-edit">
                    <input
                      type="text"
                      name="accountHolderName"
                      value={userDetails.bankDetails?.accountHolderName}
                      onChange={onUserChange}
                      placeholder="Account Holder Name"
                    />
                    {errors.accountHolderName && (
                      <p className="error">{errors.accountHolderName}</p>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="row-edit">
                    <input
                      type="text"
                      name="bankName"
                      value={userDetails.bankDetails?.bankName}
                      onChange={onUserChange}
                      placeholder="Bank Name"
                    />
                    {errors.bankName && (
                      <p className="error">{errors.bankName}</p>
                    )}
                  </div>
                  <div className="row-edit">
                    <input
                      type="text"
                      name="bankAddress"
                      value={userDetails.bankDetails?.bankAddress}
                      onChange={onUserChange}
                      placeholder="Bank Address"
                    />
                    {errors.bankAddress && (
                      <p className="error">{errors.bankAddress}</p>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="row-edit">
                    <input
                      type="text"
                      name="ifscCode"
                      value={userDetails.bankDetails?.ifscCode}
                      onChange={onUserChange}
                      placeholder="IFSC Code"
                    />
                    {errors.ifscCode && (
                      <p className="error">{errors.ifscCode}</p>
                    )}
                  </div>
                  <div className="row-edit">
                    <input
                      type="text"
                      name="swiftCode"
                      value={userDetails.bankDetails?.swiftCode}
                      onChange={onUserChange}
                      placeholder="SWIFT Code"
                    />
                    {errors.swiftCode && (
                      <p className="error">{errors.swiftCode}</p>
                    )}
                  </div>
                </div>
                <p className="input-groupOr">Or</p>
                <div className="form-row">
                  <div className="row-edit">
                    <input
                      type="text"
                      name="transitCode"
                      value={userDetails.bankDetails?.transitCode}
                      onChange={onUserChange}
                      placeholder="Transit Code"
                    />
                    {errors.transitCode && (
                      <p className="error">{errors.transitCode}</p>
                    )}
                  </div>
                  <div className="row-edit">
                    <input
                      type="text"
                      name="institutionNumber"
                      value={userDetails.bankDetails?.institutionNumber}
                      onChange={onUserChange}
                      placeholder="Institution number"
                    />
                    {errors.institutionNumber && (
                      <p className="error">{errors.institutionNumber}</p>
                    )}
                  </div>
                </div>

                <div className="other-options">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setShowOptions((prevOptions) => ({
                        ...prevOptions,
                        paypalOption: false,
                        eTranferOption: true,
                      }));
                    }}
                  >
                    E-Transfer
                  </button>
                  <p>Or</p>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setShowOptions((prevOptions) => ({
                        ...prevOptions,
                        eTranferOption: false,
                        paypalOption: true,
                      }));
                    }}
                  >
                    PayPal
                  </button>
                </div>

                {showOptions.eTranferOption && (
                  <div className="form-row">
                    <div className="row-edit">
                      <input
                        type="text"
                        name="eTranferEmail"
                        value={userDetails?.eTranferEmail}
                        onChange={onUserChange}
                        placeholder="E-Transfer Email"
                      />
                    </div>
                  </div>
                )}
                {showOptions.paypalOption && (
                  <div className="form-row">
                    <div className="row-edit">
                      <input
                        type="text"
                        name="paypalEmail"
                        value={userDetails?.paypalEmail}
                        onChange={onUserChange}
                        placeholder="PayPal Email"
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="btn-container">
            <button type="button" className="saveBtn" onClick={handleSave}>
              {loading ? (
                <div className="loading-dotss">
                  Saving<span> .</span>
                  <span>.</span>
                  <span>.</span>
                </div>
              ) : (
                "Save"
              )}
            </button>
            <button type="button" onClick={handleCancel} className="cancelBtn">
              Cancel
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default EditUser;
